import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";


export class TaskDTO {
    @AutoMap()
    position!: number;
    @AutoMap()
    description!: string;    
    @AutoMap()
    startedOn!: string;
    @AutoMap()
    endedOn!: string;
    @AutoMap()
    posture!: number;
    @AutoMap()
    repetitif!: boolean

}